import React, { forwardRef } from 'react'
import { Grid } from "@mui/material";
import Stack from '@mui/material/Stack';
import UiInput from '../../../../../../_uiMocks/_uiComponents/UiInput';
import { UiButton, UiToggleButton } from '../../../../../../_uiComponents/common/form/UiButton';
import UiInnerSearchWr from '../../../../../../_uiComponents/common/UiInnerSearchWr';
import UiDatePicker from '../../../../../_uiComponents/UiDatePicker';

export default function RewardDisributionSummaryFilterForm(props) {

    return (
        <>
            <UiInnerSearchWr>
                <Grid container spacing={2}>
                    <Grid item xs="12" lg="9" >
                        <Grid container spacing={2}>
                            <Grid item xs="12" lg="4"  >
                                <UiInput type="text" label="Allocated To" />
                            </Grid>
                            <Grid item xs="12" lg="4" >
                                <UiInput type="text" label="Allocated On" />
                            </Grid>
                            <Grid item xs="12" lg="4"  >
                                <UiDatePicker label="Rewarded On" />
                            </Grid>
                            <Grid item xs="12" lg="4"  >
                                <UiInput type="text" label="Approved By" />
                            </Grid>
                            <Grid item xs="12" lg="4" >
                                <UiDatePicker label="Approved On" />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs="12" lg="3" >
                        <Stack spacing={2} direction="row" justifyContent="end" sx={{ width: '100%', pt: 0.6 }}>
                            <UiButton name="Clear" variant="outlined" size="small" />
                            <UiButton name="Apply" variant="contained" size="small" />
                        </Stack>
                    </Grid>

                </Grid>
            </UiInnerSearchWr>



        </>
    )
}
